module.exports = "<div [attr.id]=\"'canvasWhiteboard'\">\n</div>\n"